// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetWidgetRegistrationMarketingQuestionsDefinitionRequestModel from '../../model/get-widget-registration-marketing-questions-definition-request-model';
import GetWidgetRegistrationMarketingQuestionsDefinitionRequestDTO from '../dto/get-widget-registration-marketing-questions-definition-request-dto';
import dtoSchema from '../schemas/get-widget-registration-marketing-questions-definition-request-schema';

export default abstract class GetWidgetRegistrationMarketingQuestionsDefinitionRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetWidgetRegistrationMarketingQuestionsDefinitionRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int32}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetWidgetRegistrationMarketingQuestionsDefinitionRequestDTO>): GetWidgetRegistrationMarketingQuestionsDefinitionRequestModel;
  static toModel(dto: DeepPartial<GetWidgetRegistrationMarketingQuestionsDefinitionRequestDTO> | undefined | null): GetWidgetRegistrationMarketingQuestionsDefinitionRequestModel | undefined;
  static toModel(dto: DeepPartial<GetWidgetRegistrationMarketingQuestionsDefinitionRequestDTO> | undefined | null): GetWidgetRegistrationMarketingQuestionsDefinitionRequestModel | undefined {
    return dto ? new GetWidgetRegistrationMarketingQuestionsDefinitionRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetWidgetRegistrationMarketingQuestionsDefinitionRequestModel> | GetWidgetRegistrationMarketingQuestionsDefinitionRequestModel): GetWidgetRegistrationMarketingQuestionsDefinitionRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetWidgetRegistrationMarketingQuestionsDefinitionRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetWidgetRegistrationMarketingQuestionsDefinitionRequestModel, can not map to GetWidgetRegistrationMarketingQuestionsDefinitionRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
